import { Component, Input, OnInit } from '@angular/core';

export type ButtonIconType = 'return' | 'disk' | 'plus' | 'information' | 'reload' | 'discard' | 'camera' | 'openingOfPremises' | 'airConditioners' | 'vehicular' | 'filter' | 'removeFilter' | 'download' | 'edit' | 'remove' | 'upload' | 'availabilityHistory';

@Component({
  selector: 'atom-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss']
})
export class ButtonComponent implements OnInit {
  @Input() isPrimaryButton: boolean = true;
  @Input() label: string = '';
  @Input() type: 'button' | 'submit' = 'button';
  @Input() iconType?: ButtonIconType;
  @Input() displayIcon?: boolean;
  @Input() disabled: boolean = false;
  @Input() tooltipText?: string;
  @Input() tooltipPosition: 'above' | 'below' | 'left' | 'right' = 'above';

  iconClass: string = ' ';

  iconClasses: { [key: string]: string } = {
    return: 'fa-solid fa-arrow-left',
    disk: 'fa-solid fa-floppy-disk',
    plus: 'fa-solid fa-plus',
    information: 'fa-solid fa-circle-info',
    reload: 'fa-solid fa-rotate-left',
    discard: 'fa-solid fa-xmark',
    camera: "fa-solid fa-video",
    openingOfPremises: "fa-solid fa-door-open",
    airConditioners: "fa-solid fa-temperature-low",
    vehicular: "fa-solid fa-car",
    filter: "fa-solid fa-filter",
    removeFilter: "fa-solid fa-filter-circle-xmark",
    download: "fa-solid fa-download",
    edit: "fa-solid fa-pen-to-square",
    remove: "fa-solid fa-trash",
    upload: "fa-solid fa-upload",
    availabilityHistory: "fa-solid fa-clock-rotate-left"
  };

  ngOnInit(): void {
    this.iconClass = this.iconType ? this.iconClasses[this.iconType] : ' ';
  }
}
